<template>
  <div class="animated fadeIn">
    <div
      style="gap: 1rem;"
      class="row d-flex align-items-center px-4 pt-4 pt-md-o"
    >
      <h3><i class="fas fa-balance-scale"></i> Ajuizamentos</h3>
    </div>
    <div class="w-100 mx-left col-12 py-3 px-md-4">
      <hr style="margin-top: 0" />
      <div class="d-flex flex-row flex-wrap col-12 px-0">
        <div
          class="main__content d-flex flex-row justify-content-between flex-wrap col-12 col-lg-9 px-0"
          style="width: 100%; padding: 0 !important;"
        >
          <b-card
            class="cursor-pointer"
            :class="obj.arquivado ? 'inactive d-none' : obj.isReadOnly ? 'readOnly active' : 'active'"
            id="cardCrm"
            v-for="obj in this.boards"
            :key="obj.id"
          >
            <b-card-title @click="onOpenBoard(obj)" id="cardTitle">
              {{ obj.nome }}
              <i
                v-if="obj.favorito"
                class="fas fa-star text-warning d-none"
                style="font-size: 14px"
              ></i
            ></b-card-title>
            <b-card-text @click="onOpenBoard(obj)">
              {{obj.descricao}}
            </b-card-text>
            <template #footer>
              <small class="ml-1 text-muted">
                <i class="fas fa-hourglass-half text-third text-muted"></i>
                {{ formatDeadlineDate(obj) }}
              </small>
            </template>
            <vue-fab
              v-if="
                hasRole(roles.ADMINISTRADOR) || hasRole(roles.IMPORTACAO_CARDS)
              "
              id="fabMain"
              icon="menu"
              mainBtnColor="#04a791"
              :scrollAutoHide="false"
            >
              <fab-item
                v-if="hasRole(roles.ADMINISTRADOR)"
                :idx="0"
                title="Editar Quadro de Ajuizamento"
                color="#4285f4"
                icon="mode_edit"
                @clickItem="onEdit(obj)"
              />

              <fab-item
                v-if="
                  (hasRole(roles.ADMINISTRADOR) || hasRole(roles.IMPORTACAO_CARDS)) && !obj.isReadOnly
                "
                :idx="1"
                title="Importar Quadro de Ajuizamento"
                color="#FF9900"
                icon="upload_file"
                @clickItem="onImport(obj)"
              />

              <fab-item
                v-if="hasRole(roles.ADMINISTRADOR)"
                :idx="2"
                :title="
                  obj.arquivado ? 'Desarquivar Quadro de Ajuizamento' : 'Arquivar Quadro de Ajuizamento'
                "
                :icon="obj.arquivado ? 'visibility' : 'visibility_off'"
                color="#f44"
                @clickItem="onFile(obj)"
              />
            </vue-fab>
          </b-card>
          <template v-if="showLoading">
            <b-card
              class="active cursor-pointer"
              id="cardCrm"
              v-for="numb in 4"
              v-bind:key="numb"
            >
              <b-card-title id="cardTitle">
                <b-skeleton width="40%" height="100%"></b-skeleton>
              </b-card-title>
              <b-card-text>
                <b-skeleton width="70%" height="50%"></b-skeleton>
              </b-card-text>
              <template #footer>
                <small class="ml-1 text-muted">
                  <b-skeleton width="30%"></b-skeleton>
                </small>
              </template>
            </b-card>
          </template>
          <b-card
            v-if="hasRole(roles.ADMINISTRADOR)"
            style="
              width: 100%;
              text-align: center;
              border: dotted 1px #ccc;
              cursor: pointer;
              margin-right: 10px;
              background-color: #eceff1;
            "
            class="mb-2 col-12"
            @click="onNew"
          >
            <b-card-text
              class="text-center"
              v-b-tooltip.hover
              :title="'Clique para adicionar um novo Quadro de Ajuizamento'"
            >
              <div
                class="d-flex flex-column justify-content-center align-items-center"
              >
                <i
                  class="fas fa-plus"
                  style="font-size: 50px; opacity: 0.19; padding-top: 3px"
                ></i>
                <div style="padding-top: 5px">
                  <small>Clique para adicionar</small>
                </div>
              </div>
            </b-card-text>
          </b-card>
        </div>
        <div
          class="d-flex flex-row flex-wrap col-3 side__bar"
          style="padding-right: 0"
        >
          <b-card
            id="side-menu"
            header="Ações"
            class="text-center w-100"
          >
            <b-card-text>
              <b-button-group class="w-100" vertical>
                <b-button
                  v-if="hasRole(roles.ADMINISTRADOR)"
                  class="side-menu__links"
                  squared
                  variant="outline-primary"
                  @click="onNew"
                >
                  <i class="fas fa-plus"></i> Novo Quadro de Ajuizamento</b-button
                >
                <b-button
                  class="side-menu__links"
                  squared
                  variant="outline-primary"
                  @click="viewAll"
                >
                  <i class="fas fa-th"></i> Ver Todos</b-button
                >
                <b-button
                  class="side-menu__links"
                  squared
                  variant="outline-primary"
                  @click="viewActive"
                >
                  <i class="fas fa-eye"></i> Ver Ativos</b-button
                >
                <b-button
                  class="side-menu__links"
                  squared
                  variant="outline-primary"
                  @click="viewInactive"
                >
                  <i class="fas fa-eye-slash"></i> Ver Arquivados</b-button
                >
              </b-button-group>
            </b-card-text>
          </b-card>
        </div>
      </div>
      <vue-fab
        size="big"
        id="fabMobile"
        icon="add"
        mainBtnColor="#04a791"
        class
        :scrollAutoHide="false"
      >
        <fab-item
          v-if="hasRole(roles.ADMINISTRADOR)"
          :idx="0"
          title="Novo Quadro de Ajuizamento"
          color="#4285f4"
          icon="add"
          @clickItem="onNew()"
        ></fab-item>
        <fab-item
          :idx="1"
          title="Ver Todos"
          color="#FF9900"
          icon="apps"
          @clickItem="viewAll()"
        ></fab-item>
        <fab-item
          :idx="2"
          title="Ver Ativos"
          icon="visibility"
          color="#FF9900"
          @clickItem="viewActive()"
        ></fab-item>
        <fab-item
          :idx="3"
          title="Ver Arquivados"
          icon="visibility_off"
          color="#FF9900"
          @clickItem="viewInactive()"
        ></fab-item>
      </vue-fab>
    </div>
    <CrmNewModal ref="CrmNewModal" v-on:Back="onBackNew" :isAjuizamento="true" />
    <CrmFileModal ref="CrmFileModal" v-on:Back="onBackNew" />
    <CrmDeleteModal ref="CrmDeleteModal" v-on:Back="onBackNew" />
    <CrmImportModal ref="CrmImportModal" v-on:Back="onBackNew" />
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import BoardRepository from '@/shared/http/repositories/crm/board.js'
// import { loading } from '@/shared/utils/UIHelper'
import moment from 'moment'

import CrmNewModal from './modal/crmnewmodal.vue'
import CrmDeleteModal from './modal/crmdeletemodal.vue'
import CrmImportModal from './modal/crmimportmodal.vue'
import CrmFileModal from './modal/crmfilemodal.vue'

export default {
  name: 'CRM',
  mixins: [ActionsForm],
  data () {
    return {
      boards: [],
      favorites: [],
      showLoading: true
    }
  },
  components: {
    CrmNewModal,
    CrmDeleteModal,
    CrmImportModal,
    CrmFileModal
  },
  mounted () { },
  methods: {
    onLoad () {
      // loading.push()
      BoardRepository.GetAllTipoBoard('AJUIZAMENTO')
        .then((response) => {
          // loading.pop()
          if (response.status === 200) {
            this.boards = response.data.content
            this.showLoading = false
          }
        })
        .catch((e) => {
          // loading.pop()
          console.log(e.message)
        })
    },
    onNew () {
      this.$refs.CrmNewModal.showModal()
      this.viewActive()
    },
    onEdit (obj) {
      this.$refs.CrmNewModal.showModal()
      this.$nextTick(() => {
        this.$refs.CrmNewModal.onEdit(obj)
      })
    },
    onFile (obj) {
      this.$refs.CrmFileModal.data = obj
      this.$refs.CrmFileModal.showModal()
    },
    onDelete (obj) {
      this.$refs.CrmDeleteModal.data = obj
      this.$refs.CrmDeleteModal.showModal()
    },
    onImport (obj) {
      this.$refs.CrmImportModal.showModal(obj)
    },
    onBackNew () {
      this.onLoad()
    },
    debuga (obj) {
      console.log(obj.arquivado)
    },
    onOpenBoard (obj) {
      this.$router.push({
        name: 'QuadroAjuizamento',
        params: { boardId: obj.id, backUrl: 'Ajuizamento' }
      })
    },
    formatDeadlineDate (obj) {
      let formated = ''
      if (obj.dataInicial && obj.dataFinal) {
        let startDate = moment(obj.dataInicial)
        let finalDate = moment(obj.dataFinal)
        formated = moment(finalDate).from(startDate, true) + ' restante(s)'
      }
      return formated
    },
    viewAll () {
      const elements = document.querySelectorAll('.inactive, .active')
      elements.forEach((element) => {
        element.classList.remove('d-none')
      })
    },
    viewActive () {
      const inactiveElements = document.querySelectorAll('.inactive')
      inactiveElements.forEach((element) => {
        element.classList.add('d-none')
      })
      const activeElements = document.querySelectorAll('.active')
      activeElements.forEach((element) => {
        element.classList.remove('d-none')
      })
    },
    viewInactive () {
      const inactiveElements = document.querySelectorAll('.inactive')
      inactiveElements.forEach((element) => {
        element.classList.remove('d-none')
      })
      const activeElements = document.querySelectorAll('.active')
      activeElements.forEach((element) => {
        element.classList.add('d-none')
      })
    }
  }
}
</script>
<style scoped lang="scss">
#side-menu {
  height: fit-content;

  .card-header {
    color: white;
    background: linear-gradient(90deg, #2dce89, #2dcecc);
  }

  .card-body {
    height: fit-content;
  }
}

.btn.side-menu__links.btn-outline-primary {
  border: 1px solid #cfd8dc;
  color: #04a791;
  text-align: left;

  &:hover {
    background: #04a791;
    color: white;
  }
}

.side__bar {
  @media screen and (max-width:900px) {
    display: none !important;
  }
}

.main__content {
  @media screen and (max-width:900px) {}

}

#fabMobile {
  display: none;

  @media screen and (max-width:900px) {
    display: flex;
  }
}

.readOnly {
  background: #eceff1;

  #cardTitle, .card-text {
    color: #30303057;
  }
}

.inactive {
  .card-footer {
    background: #303030;
  }

  #cardTitle {
    color: #303030;
  }
}

#cardCrm {
  padding: 0;
  width: calc(50% - 8px);
  margin-bottom: 16px;

  @media screen and (max-width:800px) {
    width: 100%;
  }
}

#cardTitle {
  text-transform: capitalize !important;
  color: #04a791;
  transition: 0.2s ease-in-out;
  word-break: break-word;

  &:hover {
    color: #027a6a;
  }
}

.custom-board-card {
  width: 322px;
  float: left;
  margin-right: 10px;
}
</style>

<style >
#fabMain {
  position: absolute;
  right: 3.5rem;
  bottom: 4rem;
}
</style>



// WEBPACK FOOTER //
// src/views/private/crm/ajuizamento.vue